// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27 fill=%27none%27%3E%3Cpath d=%27M10 2L6.70707 5.2929C6.31818 5.68179 5.68182 5.68179 5.29293 5.2929L2 2%27 stroke=%27%23003DA5%27 stroke-miterlimit=%2710%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27 fill=%27none%27%3E%3Cpath d=%27M2 6L5.29293 2.7071C5.68182 2.31821 6.31818 2.31821 6.70707 2.7071L10 6%27 stroke=%27white%27 stroke-miterlimit=%2710%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DSBP-heading-container {
  display: flex;
}
.DSBP-heading-container .bu-dropdown-container {
  display: flex;
  margin-left: 10px;
}
.DSBP-heading-container .bu-dropdown-container .dropdown-container {
  margin-right: 10px;
}

.toggle-btn .toggle-btn-allocated {
  border-color: #007bff;
  font-size: 12px;
  width: 80px;
  gap: 10px;
  padding: 0.5rem 1rem 0.5rem 1rem;
  border-radius: 1.25rem 0 0 1.25rem;
  border: 0.063rem solid #003da5;
  margin-left: 1rem;
}
.toggle-btn .toggle-btn-unallocated {
  border-color: #007bff;
  width: 100px;
  gap: 10px;
  padding: 0.5rem 1rem 0.5rem 1rem;
  border-radius: 0 1.25rem 1.25rem 0;
  border: 0.063rem solid #003da5;
}
.toggle-btn .active {
  background-color: #003da5;
  color: #ffffff;
}
.toggle-btn .deactive {
  background-color: #ffffff;
  color: #595959;
}

.p-confirm-popup {
  position: absolute;
  top: 12% !important;
  left: 0% !important;
}

.p-datepicker table td {
  padding: 0.2px !important;
}

.p-button:focus {
  box-shadow: none !important;
}

.DSBPScreenList .actions {
  padding: 0 20px;
}
.DSBPScreenList .p-datatable > .p-datatable-wrapper {
  overflow: auto;
  width: 100%;
  height: calc(100vh - 200px);
}
@media only screen and (max-width: 1024px) {
  .DSBPScreenList .p-datatable > .p-datatable-wrapper {
    height: calc(100vh - 200px);
  }
}
.DSBPScreenList .p-column-title {
  font-weight: 400;
}
.DSBPScreenList .p-column-title span {
  font-size: 12px;
  /* width: 10px; */
  align-items: center;
  line-height: 1;
}
.DSBPScreenList .p-datatable-tbody {
  font-weight: 400;
}
.DSBPScreenList.dsbp-wrapper .p-datatable {
  height: calc(100% - 220px);
}

.font-bold {
  font-weight: 700;
}

.p-checkbox {
  margin: 8px 8px 8px 8px;
}

.p-checkbox-checked + label {
  color: #003da5;
}

.ml-2 {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
}

img[disabled] {
  opacity: 0.5;
  cursor: no-drop;
}

.clearAllFilterMainDiv {
  display: flex;
  padding: 10.56px 22px 22px 2px;
}

.clearAllFilterDiv {
  line-height: 12px;
  justify-items: end;
  display: flex;
  position: absolute;
  right: 22px;
  top: 18px;
}

.clearAllFilter {
  cursor: pointer;
}

.clearAllFilterIcon {
  cursor: pointer;
  position: absolute;
  right: 5px;
}

.sortAndFrozen {
  padding: 0 22px 22px 2px;
  cursor: pointer;
  line-height: 12px;
}

.multiSelect {
  cursor: pointer;
  line-height: 10px;
}
.multiSelect .p-placeholder {
  color: #595959 !important;
}
.multiSelect .p-multiselect {
  width: 124px !important;
}

.p-overlaypanel {
  position: absolute !important;
}

.p-multiselect-item {
  font-size: 10px !important;
  line-height: 12px !important;
  padding: 0px 0 !important;
}

.p-inputtext {
  font-size: 10px !important;
  line-height: 12px !important;
  font-family: Montserrat !important;
}

.action-button {
  border-radius: 20px;
  box-shadow: 0 0 0 1px #003da5;
}

.p-dropdown-item:hover {
  background-color: #edf4fa !important;
}

div.actions-right {
  display: flex;
  flex-direction: row;
}
div.actions-right:nth-child(2) {
  margin-left: 12px;
}

.justify-content-center,
.justify-content-center1 {
  border: none !important;
}

.justify-content-center1 {
  margin-left: 15px;
}

div.p-button.p-component:nth-child(1) {
  border-radius: 12px 0 0 12px;
}

div.p-button.p-component:nth-child(2) {
  background-color: #acacac !important;
  color: white !important;
  border-radius: 0 12px 12px 0;
}

div.p-selectbutton.p-buttonset.p-component {
  border: none;
}

.p-selectbutton .p-button.p-highlight {
  border-color: grey !important;
}

.p-selectbutton .p-button {
  border-color: grey;
}

.apply-filter-text {
  color: "#003DA5" !important;
}

.filter-color-change {
  filter: invert(10%) sepia(100%) saturate(1200%) hue-rotate(204deg) brightness(60%) contrast(135%);
}

.checkbox-columnnames {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.checkbox-columnnames label {
  margin-bottom: 0px;
  margin-top: 3px;
}

#tasksActions {
  background: #003da5;
  font-size: 12px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 20px;
  border: 0;
  margin: 0;
}

.dropdown {
  background: transparent;
  font-size: 12px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 20px;
  border: 0;
}
.dropdown:focus-visible {
  outline: none;
}

.dropdown-item, .artwork-dsbp .dropdown-item {
  font-size: 12px;
  padding: 11px 16px;
  color: #595959;
}
.dropdown-item:hover:last-child {
  border-radius: 0 0 8px 8px;
}
.dropdown-item:hover:first-child {
  border-radius: 8px 8px 0 0;
}
.dropdown-item.active, .dropdown-item:hover {
  background: #edf4fa !important;
  color: #003da5;
}
.dropdown-item:focus {
  outline: none;
}

.artwork-dsbp .dropdown-item.active, .artwork-dsbp .dropdown-item:hover {
  background: #edf4fa !important;
  color: #003da5;
}

.dropdown-menu {
  padding: 0;
}

#tasksInActive {
  background-color: #fff !important;
  border-color: #003da5 !important;
  color: #003da5 !important;
  opacity: 1;
}

.dropdown-button-custom #tasksInActive::after {
  content: "";
  display: inline-block;
  width: 12px;
  height: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  border: 0;
}

.dropdown-button-custom .btn[aria-expanded=true]::after,
.dropdown-button-custom .btn[aria-expanded=false]::after {
  content: "";
  display: inline-block;
  width: 12px;
  height: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: contain;
  border: 0;
  transform: rotate(0deg);
}

.dropdown-button-custom .btn[aria-expanded=false]::after {
  transform: rotate(180deg);
}

.text-option {
  min-width: 10.875rem;
  display: inline-block;
}

.btn-sml {
  height: 2vh !important;
  padding: 0.7rem 0.5rem !important;
  font-size: 0.8rem !important;
}

.projectId {
  color: #003DA5;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/DSBPScreen/index.scss"],"names":[],"mappings":"AAIA;EACE,aAAA;AAHF;AAKE;EACE,aAAA;EACA,iBAAA;AAHJ;AAKI;EACE,kBAAA;AAHN;;AASE;EACE,qBAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,gCAAA;EACA,kCAAA;EACA,8BAAA;EACA,iBAAA;AANJ;AASE;EACE,qBAAA;EACA,YAAA;EACA,SAAA;EACA,gCAAA;EACA,kCAAA;EACA,8BAAA;AAPJ;AAUE;EACE,yBAAA;EACA,cAAA;AARJ;AAWE;EACE,yBAAA;EACA,cAAA;AATJ;;AAaA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;AAVF;;AAcA;EACE,yBAAA;AAXF;;AAcA;EACE,2BAAA;AAXF;;AAgBE;EACE,eAAA;AAbJ;AAgBE;EACE,cAAA;EACA,WAxEO;EAyEP,2BAAA;AAdJ;AAgBI;EALF;IAMI,2BAAA;EAbJ;AACF;AAoBE;EACE,gBAnFY;AAiEhB;AAoBI;EACE,eAAA;EACA,iBAAA;EAEA,mBAAA;EACA,cAAA;AAnBN;AAuBE;EACE,gBA/FY;AA0EhB;AA4CI;EACE,0BAAA;AA1CN;;AA+CA;EACE,gBAAA;AA5CF;;AA+CA;EACE,uBAAA;AA5CF;;AA+CA;EACE,cAAA;AA5CF;;AA+CA;EACE,gBAzIc;EA0Id,eAAA;EACA,iBAAA;AA5CF;;AAgDA;EACE,YAAA;EAEA,eAAA;AA9CF;;AAoDA;EACE,aAAA;EACA,8BAAA;AAjDF;;AAoDA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAjDF;;AAoDA;EACE,eAAA;AAjDF;;AAoDA;EACE,eAAA;EACA,kBAAA;EACA,UAAA;AAjDF;;AAoDA;EACE,wBAAA;EACA,eAAA;EACA,iBAAA;AAjDF;;AAoDA;EACE,eAAA;EACA,iBAAA;AAjDF;AAmDE;EAEE,yBAAA;AAlDJ;AAqDE;EACE,uBAAA;AAnDJ;;AAwDA;EACE,6BAAA;AArDF;;AAwDA;EACE,0BAAA;EACA,4BAAA;EACA,yBAAA;AArDF;;AAwDA;EACE,0BAAA;EACA,4BAAA;EACA,kCAAA;AArDF;;AAyDA;EACE,mBAAA;EACA,6BAAA;AAtDF;;AAgEA;EACE,oCAAA;AA7DF;;AAgEA;EACE,aAAA;EACA,mBAAA;AA7DF;AA+DE;EACE,iBAAA;AA7DJ;;AAiEA;;EAEE,uBAAA;AA9DF;;AAiEA;EACE,iBAAA;AA9DF;;AAiEA;EACE,4BAAA;AA9DF;;AAiEA;EACE,oCAAA;EACA,uBAAA;EACA,4BAAA;AA9DF;;AAiEA;EACE,YAAA;AA9DF;;AAiEA;EACE,6BAAA;AA9DF;;AAiEA;EACE,kBAAA;AA9DF;;AAiEA;EACE,2BAAA;AA9DF;;AAiEA;EACE,iGAAA;AA9DF;;AAiEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AA9DF;AAgEE;EACE,kBAAA;EACA,eAAA;AA9DJ;;AAkEA;EACE,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;AA/DF;;AAkEA;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,SAAA;AA/DF;AAiEE;EACE,aAAA;AA/DJ;;AAmEA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;AAhEF;AAkEE;EACE,0BAAA;AAhEJ;AAmEE;EACE,0BAAA;AAjEJ;AAoEE;EAEE,8BAAA;EACA,cAAA;AAnEJ;AAsEE;EACE,aAAA;AApEJ;;AA4EI;EAEE,8BAAA;EACA,cAAA;AA1EN;;AA+EA;EACE,UAAA;AA5EF;;AA+EA;EACE,iCAAA;EACA,gCAAA;EACA,yBAAA;EACA,UAAA;AA5EF;;AA+EA;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,SAAA;AA5EF;;AA+EA;;EAEE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,SAAA;EACA,uBAAA;AA5EF;;AA+EA;EACE,yBAAA;AA5EF;;AA+EA;EACE,oBAAA;EACA,qBAAA;AA5EF;;AA+EA;EACE,sBAAA;EACA,iCAAA;EACA,4BAAA;AA5EF;;AA0FA;EACE,cAAA;EACA,eAAA;AAvFF","sourcesContent":["$width100: 100%;\n$fontWeight500: 500;\n$fontWeight400: 400;\n\n.DSBP-heading-container {\n  display: flex;\n\n  .bu-dropdown-container {\n    display: flex;\n    margin-left: 10px;\n\n    .dropdown-container {\n      margin-right: 10px;\n    }\n  }\n}\n\n.toggle-btn {\n  .toggle-btn-allocated {\n    border-color: #007bff;\n    font-size: 12px;\n    width: 80px;\n    gap: 10px;\n    padding: 0.5rem 1rem 0.5rem 1rem;\n    border-radius: 1.25rem 0 0 1.25rem;\n    border: 0.063rem solid #003da5;\n    margin-left: 1rem;\n  }\n\n  .toggle-btn-unallocated {\n    border-color: #007bff;\n    width: 100px;\n    gap: 10px;\n    padding: 0.5rem 1rem 0.5rem 1rem;\n    border-radius: 0 1.25rem 1.25rem 0;\n    border: 0.063rem solid #003da5;\n  }\n\n  .active {\n    background-color: #003da5;\n    color: #ffffff;\n  }\n\n  .deactive {\n    background-color: #ffffff;\n    color: #595959;\n  }\n}\n\n.p-confirm-popup {\n  position: absolute;\n  top: 12% !important;\n  left: 0% !important;\n}\n\n// Datepicker for ProjectSetUp component Style Start\n.p-datepicker table td {\n  padding: 0.2px !important;\n}\n\n.p-button:focus {\n  box-shadow: none !important;\n}\n\n// Datepicker for ProjectSetUp component Style End\n.DSBPScreenList {\n  .actions {\n    padding: 0 20px;\n  }\n\n  .p-datatable>.p-datatable-wrapper {\n    overflow: auto;\n    width: $width100;\n    height: calc(100vh - 200px);\n\n    @media only screen and (max-width: 1024px) {\n      height: calc(100vh - 200px);\n    }\n  }\n\n  // .p-datatable-table {\n  //   line-height: 12px;\n  // }\n\n  .p-column-title {\n    font-weight: $fontWeight400;\n\n    span {\n      font-size: 12px;\n      /* width: 10px; */\n      // margin-left: 2px;\n      align-items: center;\n      line-height: 1;\n    }\n  }\n\n  .p-datatable-tbody {\n    font-weight: $fontWeight400;\n  }\n\n  // .p-datatable .p-datatable-tbody>tr>td {\n  //   padding: 2px 6px !important;\n  //   line-height: 30px;\n  // }\n\n  // th:after,\n  // td:after {\n  //   content: \"\";\n  //   display: block;\n  //   height: 22px;\n  //   width: 0.8px;\n  //   background-color: #acacac;\n  //   position: absolute;\n  //   top: 25%;\n  //   right: 0;\n\n  // }\n\n\n  &.dsbp-wrapper {\n    .p-datatable {\n      height: calc(100% - 220px);\n    }\n  }\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.p-checkbox {\n  margin: 8px 8px 8px 8px;\n}\n\n.p-checkbox-checked+label {\n  color: #003da5;\n}\n\n.ml-2 {\n  font-weight: $fontWeight400;\n  font-size: 14px;\n  line-height: 17px;\n}\n\n// Filter and Save buttons disabled\nimg[disabled] {\n  opacity: 0.5;\n  // pointer-events: none;\n  cursor: no-drop;\n}\n\n// ProjectList Styles End\n\n// ConfirmationPopUp Styles Start\n.clearAllFilterMainDiv {\n  display: flex;\n  padding: 10.56px 22px 22px 2px;\n}\n\n.clearAllFilterDiv {\n  line-height: 12px;\n  justify-items: end;\n  display: flex;\n  position: absolute;\n  right: 22px;\n  top: 18px;\n}\n\n.clearAllFilter {\n  cursor: pointer;\n}\n\n.clearAllFilterIcon {\n  cursor: pointer;\n  position: absolute;\n  right: 5px;\n}\n\n.sortAndFrozen {\n  padding: 0 22px 22px 2px;\n  cursor: pointer;\n  line-height: 12px;\n}\n\n.multiSelect {\n  cursor: pointer;\n  line-height: 10px;\n\n  .p-placeholder {\n    // font-size: 8px !important;\n    color: #595959 !important;\n  }\n\n  .p-multiselect {\n    width: 124px !important;\n    // height: 16px !important;\n  }\n}\n\n.p-overlaypanel {\n  position: absolute !important;\n}\n\n.p-multiselect-item {\n  font-size: 10px !important;\n  line-height: 12px !important;\n  padding: 0px 0 !important;\n}\n\n.p-inputtext {\n  font-size: 10px !important;\n  line-height: 12px !important;\n  font-family: Montserrat !important;\n}\n\n// Container header section\n.action-button {\n  border-radius: 20px;\n  box-shadow: 0 0 0 1px #003da5;\n}\n\n// div.p-dropdown-panel{\n//   height: 111px !important;\n//   width: 186px !important;\n//   top: 185.667px !important;\n//   left: 1043.06px !important;\n//   border: solid 1px #003DA5;\n// }\n.p-dropdown-item:hover {\n  background-color: #edf4fa !important;\n}\n\ndiv.actions-right {\n  display: flex;\n  flex-direction: row;\n\n  &:nth-child(2) {\n    margin-left: 12px;\n  }\n}\n\n.justify-content-center,\n.justify-content-center1 {\n  border: none !important;\n}\n\n.justify-content-center1 {\n  margin-left: 15px;\n}\n\ndiv.p-button.p-component:nth-child(1) {\n  border-radius: 12px 0 0 12px;\n}\n\ndiv.p-button.p-component:nth-child(2) {\n  background-color: #acacac !important;\n  color: white !important;\n  border-radius: 0 12px 12px 0;\n}\n\ndiv.p-selectbutton.p-buttonset.p-component {\n  border: none;\n}\n\n.p-selectbutton .p-button.p-highlight {\n  border-color: grey !important;\n}\n\n.p-selectbutton .p-button {\n  border-color: grey;\n}\n\n.apply-filter-text {\n  color: \"#003DA5\" !important;\n}\n\n.filter-color-change {\n  filter: invert(10%) sepia(100%) saturate(1200%) hue-rotate(204deg) brightness(60%) contrast(135%);\n}\n\n.checkbox-columnnames {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n\n  label {\n    margin-bottom: 0px;\n    margin-top: 3px;\n  }\n}\n\n#tasksActions {\n  background: #003da5;\n  font-size: 12px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  border-radius: 20px;\n  border: 0;\n  margin: 0;\n}\n\n.dropdown {\n  background: transparent;\n  font-size: 12px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  border-radius: 20px;\n  border: 0;\n\n  &:focus-visible {\n    outline: none;\n  }\n}\n\n.dropdown-item {\n  font-size: 12px;\n  padding: 11px 16px;\n  color: #595959;\n\n  &:hover:last-child {\n    border-radius: 0 0 8px 8px;\n  }\n\n  &:hover:first-child {\n    border-radius: 8px 8px 0 0;\n  }\n\n  &.active,\n  &:hover {\n    background: #edf4fa !important;\n    color: #003da5;\n  }\n\n  &:focus {\n    outline: none;\n  }\n}\n\n.artwork-dsbp {\n  .dropdown-item {\n    @extend .dropdown-item;\n\n    &.active,\n    &:hover {\n      background: #edf4fa !important;\n      color: #003da5;\n    }\n  }\n}\n\n.dropdown-menu {\n  padding: 0;\n}\n\n#tasksInActive {\n  background-color: #fff !important;\n  border-color: #003da5 !important;\n  color: #003da5 !important;\n  opacity: 1;\n}\n\n.dropdown-button-custom #tasksInActive::after {\n  content: \"\";\n  display: inline-block;\n  width: 12px;\n  height: 8px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8' fill='none'%3E%3Cpath d='M10 2L6.70707 5.2929C6.31818 5.68179 5.68182 5.68179 5.29293 5.2929L2 2' stroke='%23003DA5' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  border: 0;\n}\n\n.dropdown-button-custom .btn[aria-expanded=\"true\"]::after,\n.dropdown-button-custom .btn[aria-expanded=\"false\"]::after {\n  content: \"\";\n  display: inline-block;\n  width: 12px;\n  height: 8px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8' fill='none'%3E%3Cpath d='M2 6L5.29293 2.7071C5.68182 2.31821 6.31818 2.31821 6.70707 2.7071L10 6' stroke='white' stroke-miterlimit='10' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  border: 0;\n  transform: rotate(0deg);\n}\n\n.dropdown-button-custom .btn[aria-expanded=\"false\"]::after {\n  transform: rotate(180deg);\n}\n\n.text-option {\n  min-width: 10.875rem;\n  display: inline-block;\n}\n\n.btn-sml { \n  height: 2vh !important;\n  padding: 0.7rem 0.5rem !important;\n  font-size: 0.8rem !important; \n}\n\n// .myProjectAnddAllProjectList table td,\n// .myProjectAnddAllProjectList table .p-datatable .p-datatable-tbody>tr>td,\n// .my-task-project table td,\n// .my-task-project table .p-datatable .p-datatable-tbody {\n//   background: none !important;\n// }\n\n// .p-datatable .p-column-header-content {\n//   justify-content: center;\n// }\n\n.projectId {\n  color: #003DA5;\n  cursor: pointer\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
